module.exports = __webpack_public_path__ + "static/media/groove.c3142d40.png";